import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import usuarioUtil from '@/util/usuarioUtil'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import constants from '@/util/constants'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'
import { mapState } from 'vuex'
import { filtrosMixin } from '@/modules/filtros/mixins'

export default {
  name: 'usuarios',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    imageStream,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  mixins: [ filtrosMixin ],
  data: () => {
    return {
      listaUsuarios: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      camposFiltroPesquisa: {
        nome: null,
        email: null,
        status: [constants.statusUsuario.ativo, constants.statusUsuario.loginNaoRealizado]
      },
      filtrosPesquisa: [],
      componenteOrdenacao: {
        campo: 'f_name',
        sentido: 'asc'
      },
      statusFiltroOptions: [
        { text: '', value: null },
        { text: 'Ativo', value: [constants.statusUsuario.ativo, constants.statusUsuario.loginNaoRealizado] },
        { text: 'Inativo', value: [constants.statusUsuario.inativo] }
      ],
      items: [],
      fields: [
        { key: 'f_name', sortable: true, label: 'Nome' },
        { key: 'f_username', sortable: true, label: 'Login' },
        { key: 'f_status',
          sortable: true,
          label: 'Status',
          formatter: (value) => {
            switch (value) {
              case constants.statusUsuario.inativo:
                return constants.statusUsuario.inativoLabel
              case constants.statusUsuario.ativo:
                return constants.statusUsuario.ativoLabel
              case constants.statusUsuario.loginNaoRealizado:
                return constants.statusUsuario.loginNaoRealizadoLabel
            }
          }
        }
      ]
    }
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina'])
  },

  mounted () {
    this.definirContexto('usuario')
    this.camposFiltroPesquisa = this.inicializarFiltrosPesquisa(this.camposFiltroPesquisa)
    this.componenteOrdenacao = this.inicializarComponenteOrdenacao(this.componenteOrdenacao)
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    // this.filtrarSomenteUsuariosAtivos()
    this.buscarRegistros()
  },

  methods: {
    limparFiltros () {
      this.limparFiltrosPesquisa()
      this.camposFiltroPesquisa = {
        nome: null,
        email: null,
        status: [constants.statusUsuario.ativo, constants.statusUsuario.loginNaoRealizado]
      }
      this.limparComponenteOrdenacao()
      this.componenteOrdenacao = {
        campo: 'f_name',
        sentido: 'asc'
      }
    },
    usuarioTemFoto (fotoUsuario) {
      return usuarioUtil.usuarioTemFoto(fotoUsuario)
    },

    filtrarSomenteUsuariosAtivos () {
      this.filtrosPesquisa = {
        'f_status': [constants.statusUsuario.ativo, constants.statusUsuario.loginNaoRealizado]
      }
    },

    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    destacarUsuarioInativo (valor) {
      if (valor === constants.statusUsuario.inativo) {
        return 'text-secondary'
      } else {
        return 'textos'
      }
    },

    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'
        this.salvarComponenteOrdenacao(this.componenteOrdenacao)
        this.obterListaUsuarios()
      }
    },

    async obterListaUsuarios () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': this.filtrosPesquisa,
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post('/usuarios', parametrosRequisicao)
        this.listaUsuarios = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaUsuarios()
    },

    incluirUsuario () {
      this.$router.push({ name: 'cadastro-usuarios' })
    },

    editarUsuario (id) {
      this.$router.push({ name: 'edicao-usuario-administracao', params: { id: id } })
    },

    buscarRegistros () {
      this.filtrosPesquisa = util.mapearObjetos(this.camposFiltroPesquisa, {})
      this.filtrosPesquisa = {
        'f_name': this.camposFiltroPesquisa.nome,
        'f_email': this.camposFiltroPesquisa.email,
        'f_status': this.camposFiltroPesquisa.status
      }
      this.componentePaginacao.pagina = 1
      this.salvarFiltrosPesquisa(this.camposFiltroPesquisa)
      this.salvarComponenteOrdenacao(this.componenteOrdenacao)
      this.obterListaUsuarios()
    }
  }
}
